export const USE_CASE_DESCRIPTIONS: Record<string, string> = {
  AppointmentManagement:
    'Keeps already-booked appointments on track with reminders, confirmations, cancellations, rescheduling, and no-show follow-up.',
  CareGapClosure:
    'Finds patients with open quality or preventive care gaps and drives the action that closes them.',
  ChartReview:
    'Reads the chart to summarize, verify, or surface clinical findings for someone to act on.',
  ClinicalInformationCollection:
    'Collects clinical information — questionnaires, screeners, and histories — from patients or staff and writes it back to the chart.',
  CoordinationOfCare:
    'Moves information and tasks between care team members, sites, and outside providers so care stays connected.',
  DenialManagement:
    "Works denied and pended claims — identifies the reason, assembles what's needed to allow staff to resubmit or appeal.",
  DocumentSorting:
    'Classifies inbound documents by type and routes them to the right queue or team.',
  DocumentIndexing:
    'Matches a document to the right patient, encounter, or order and files it in the chart with the correct metadata.',
  DocumentOrderTranscription:
    'Pulls the content of a document into discrete data or a downstream action.',
  HCC: 'Surfaces suspected risk-adjustment conditions so providers can confirm and code them at the visit.',
  InboundCallDeflection:
    'Handles inbound patient calls and requests automatically, resolving them or triaging them to the right place.',
  PatientCommunication:
    'Sends patients information they need — announcements, alerts, surveys, and updates.',
  PaymentCollection: 'Determines what the patient owes and collects it.',
  PriorAuthorization:
    'Determines whether a service needs payer authorization and gets it approved before care is delivered.',
  NoticeOfAdmission:
    'Notifies the payer of an admission within the required window and tracks acknowledgment.',
  RegistrationAndIntake:
    'Gets the patient registered before the visit — demographics, insurance, ID, and consents verified and in the system.',
  Scheduling: 'Gets a patient booked into the right visit with the right provider.',
  Other: "Doesn't fit any of the above — pick this only when nothing else applies.",
};
